var map = {
	"./common_arrow_down_icon.svg": "d4f0",
	"./common_search_icon.svg": "9c3c",
	"./star.svg": "708a",
	"./wxa-select-icon.svg": "218e",
	"./zltd-icon.svg": "5fe9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";